import { camelCase } from 'lodash';
import { useEffect } from 'react';
import { StatusPermission } from '../../enum';
import { useAPI } from '../../state';
var USER_SESSION_API = '/api/user/me';
var AUDIT_LOGOUT_API = '/api/auth/auditLogout';
export var TABLE_PREFS_API = '/api/user/tablePreferences';
export var useUserSessionAPI = function () {
  return useAPI(USER_SESSION_API);
};
export var useUserPermissionsAPI = function () {
  var _a, _b, _c;
  var data = useAPI(USER_SESSION_API)[0].data;
  var userOrg = ((data === null || data === void 0 ? void 0 : data.userOrgs) || [])[0];
  return {
    capacityPermission: userOrg === null || userOrg === void 0 ? void 0 : userOrg.capacityPermission,
    financialPermission: ((_a = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _a === void 0 ? void 0 : _a.financialLicense) ? userOrg === null || userOrg === void 0 ? void 0 : userOrg.financialPermission : StatusPermission.Hide,
    recruitmentPermission: ((_b = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _b === void 0 ? void 0 : _b.recruitmentLicense) ? userOrg === null || userOrg === void 0 ? void 0 : userOrg.recruitmentPermission : StatusPermission.Hide,
    actualPermission: ((_c = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _c === void 0 ? void 0 : _c.actualLicense) ? userOrg === null || userOrg === void 0 ? void 0 : userOrg.actualPermission : StatusPermission.Hide,
    orgConfigPermission: userOrg === null || userOrg === void 0 ? void 0 : userOrg.orgConfigPermission
  };
};
export var useOrgConfigPermission = function () {
  var _a;
  var data = useAPI(USER_SESSION_API)[0].data;
  var userOrg = ((data === null || data === void 0 ? void 0 : data.userOrgs) || [])[0];
  return (_a = userOrg === null || userOrg === void 0 ? void 0 : userOrg.orgConfigPermission) !== null && _a !== void 0 ? _a : StatusPermission.Hide;
};
/** True when the user's org has the Dashboards (embedded Superset BI) license enabled. */
export var useDashboardLicense = function () {
  var _a;
  var data = useAPI(USER_SESSION_API)[0].data;
  return !!((_a = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _a === void 0 ? void 0 : _a.dashboardLicense);
};
/** True when the user's org plans across locations (multi-geo). */
export var useMultiGeoEnabled = function () {
  var _a;
  var data = useAPI(USER_SESSION_API)[0].data;
  return !!((_a = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _a === void 0 ? void 0 : _a.multiGeoEnabled);
};
export var UserSessionLoader = function () {
  var _a = useUserSessionAPI(),
    fetchUserSessionData = _a[1];
  useEffect(function () {
    fetchUserSessionData();
  }, [fetchUserSessionData]);
  return null;
};
export var usePlatformContext = function () {
  var _a;
  var data = useUserSessionAPI()[0].data;
  return camelCase((_a = data === null || data === void 0 ? void 0 : data.orgs[0]) === null || _a === void 0 ? void 0 : _a.orgType);
};
export var useAuditLogoutAPI = function () {
  return useAPI(AUDIT_LOGOUT_API);
};